import React from 'react';
import { Grid, Chip, TextField, Button } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedSelect from '../../../Components/OutlinedSelect';
import { USER_ROLES } from 'utils/constants';

export default function CreateUserForm({
    formState,
    handleInputChange,
    handleChangeCustomer,
    companyList,
    customers,
    roleList,
    userDetails,
    userNameDisable,
    emailDisable,
    projectList,
    isOnbaording,
    showProject,
    showPassword,
    onGeneratePassword
}) {
    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="First Name *"
                        name="firstName"
                        value={formState.firstName}
                        type="text"
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Surname *"
                        name="lastName"
                        value={formState.lastName}
                        type="text"
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Username *"
                        name="userName"
                        value={formState.userName}
                        placeholder="Username (same as Email)"
                        disabled={true}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Email *"
                        name="email"
                        value={formState.email}
                        type="email"
                        disabled={!!emailDisable}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Autocomplete
                        multiple
                        id="tags-outlined"
                        value={customers}
                        name="customers"
                        options={companyList || []}
                        getOptionLabel={option => option.name}
                        onChange={(event, newValue) => {
                            handleChangeCustomer(newValue, 'customers');
                        }}
                        limitTags={2}
                        fullWidth
                        renderTags={(value, getTagProps) => value.map((option, index) => (
                            <Chip variant="outlined" size="small" label={option.name} {...getTagProps({ index })} />
                        ))}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                size="small"
                                fullWidth
                                label="Company Name *"
                            />
                        )}
                    />
                </Grid>
                {roleList && roleList.length &&
                    <Grid item xs={12} md={4}>
                        <OutlinedSelect
                            val={formState.role}
                            name="role"
                            label="Role *"
                            variant="outlined"
                            handleChange={handleInputChange}
                            styleOverrides={{ width: '100%', marginTop: 0 }}
                            options={roleList}
                        />
                    </Grid>
                }
                {!(roleList && roleList.length) &&
                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Location *"
                            name="location"
                            value={formState.location}
                            type="text"
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
            </Grid>
            <Grid container spacing={3}>
                {roleList && roleList.length && ['superadmin', 'customeradmin', 'projectadmin'].includes(formState.role) &&
                    ['superadmin', 'customeradmin'].includes(userDetails?.role) &&
                    <Grid item xs={12} md={4}>
                        <OutlinedSelect
                            val={formState.sub_role}
                            name="sub_role"
                            label="Secondary Role *"
                            variant="outlined"
                            handleChange={(evt) => handleInputChange(evt)}
                            styleOverrides={{ width: '100%', marginTop: 0 }}
                            options={[{ id: 'gcologist', name: 'GCologist' }]}
                        />
                    </Grid>
                }
                {roleList && roleList.length &&
                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Location *"
                            name="location"
                            value={formState.location}
                            type="text"
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
                {((userDetails?.role === USER_ROLES.SUPER_ADMIN || userDetails?.role === USER_ROLES.CUSTOMER_ADMIN) || showProject) && projectList && !isOnbaording &&
                    <Grid item xs={12} md={4}>
                        <Autocomplete
                            value={formState.project || null}
                            options={projectList || []}
                            getOptionLabel={(option) => (option && option.name) || ''}
                            onChange={(event, newValue) => handleChangeCustomer(newValue, 'project')}
                            fullWidth
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="Project *"
                                />
                            )}
                        />
                    </Grid>
                }
                {showPassword &&
                    <Grid item xs={12} md={4}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Password"
                            name="password"
                            value={formState.password || ''}
                            type="text"
                            onChange={handleInputChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={onGeneratePassword}
                                            style={{ color: '#fff', textTransform: 'none' }}
                                        >
                                            Generate
                                        </Button>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                }
            </Grid>
        </div>
    );
}